var N = /*           */ ((r) => (r.Init = "module-init", r.Processing = "processing", r.Custom = "custom", r))(N || {}), A = /*           */ ((r) => (r.CmpInit = "cmp-init", r.CBLoad = "load", r.CbLoadStyles = "load-styles", r.ArchiveReceipt = "archiveReceipt", r.LogInfo = "log-info", r.LogWarn = "log-warn", r))(A || {}), w = /*           */ ((r) => (r.Success = "success", r.Failure = "fail", r.LogWarn = "log-warn", r.LogInfo = "log-info", r.CbLoadSuccess = "load-show-banner", r.CbLoadError = "no-consent-provider", r.CBHidden = "hidden", r))(w || {});
const b = [
  "success",
  "fail"
  /*         */
], I = {
  type: "module-init",
  actions: [
    { type: "cmp-init", results: b },
    { type: "load-styles", results: b },
    {
      type: "load",
      results: [
        "no-consent-provider",
        "load-show-banner",
        "hidden"
        /*          */
      ]
    }
  ]
}, W = {
  type: "processing",
  actions: [{ type: "archiveReceipt", results: b }]
}, v = {
  type: "custom",
  actions: [
    { type: "log-info", results: [
      "log-info"
      /*         */
    ] },
    { type: "log-warn", results: [
      "log-warn"
      /*         */
    ] }
  ]
}, $ = [
  I,
  W,
  v
], y = window;
y.o_global ||= {}, y.o_util ||= {};
const { o_util: F } = y, T = y.otto ?? {}, p = T.apm ?? {};
p.agent;
p.isActive;
p.getCurrentTransaction;
const _ = p.startSpan, j = p.captureError;
p.mark;
p.addLabels;
p.sendCustomError;
const O = F.apm ?? {};
O.runWithSpan;
O.withSpan;
function D(r) {
  return typeof r == "object" && r !== null && "then" in r && typeof r.then == "function";
}
class k {
  constructor(t, e, n) {
    this.type = t, this.team = e, this.service = n;
  }
  spanRegistry = /*           */ new Map();
  async startSpan(t, e, n, a = { blocking: !0 }) {
    const l = this.createType(e);
    try {
      const u = await _(t, l, a);
      if (u)
        return this.spanRegistry.set(t, u), u.addLabels({
          team: this.team,
          service: this.service,
          ...n
        }), {
          end: (f, g) => this.endSpan(t, f, g),
          addLabels: u.addLabels.bind(
            u
          ),
          type: l
        };
    } catch {
    }
  }
  endSpan(t, e, n) {
    try {
      const a = this.spanRegistry.get(t);
      if (!a)
        return;
      a.addLabels({ spanResult: e, ...n }), a.end(), this.spanRegistry.delete(t);
    } catch {
    }
  }
  withSpan(t, e) {
    const {
      name: n,
      action: a,
      extraLabels: l,
      successResult: u,
      failureResult: f,
      extraOptions: g
    } = e;
    return (...M) => {
      const E = this.startSpan(
        n,
        a,
        l,
        g
      ), o = (s = !0) => void E.then((i) => {
        const c = s ? u : f ?? u;
        i?.end(c);
      });
      try {
        const s = t(...M);
        return D(s) ? s.then((i) => (o(), i)).catch((i) => (o(!1), Promise.reject(i))) : (o(), s);
      } catch (s) {
        throw o(!1), s;
      }
    };
  }
  createType(t) {
    return `${this.type}.${this.service}.${t}`;
  }
}
function x(r, t, e) {
  const n = $.find(
    ({ type: o }) => o === r
  ), a = new k(r, t, e);
  if (typeof n > "u")
    throw new Error("Unsupported MeasureType: " + r);
  const l = {};
  for (const o of n.actions) {
    const s = o, i = o.type, c = E(r, i);
    Object.assign(l, {
      ...u(i, c),
      ...f(i, c, s),
      ...g(i, c),
      ...M(i, c)
    });
  }
  return l;
  function u(o, s) {
    return {
      [`start${S(o)}`]: async (c) => a.startSpan(s, o, c)
    };
  }
  function f(o, s, i) {
    return {
      [`end${S(o)}`]: (h, m) => {
        const d = i.results.find(
          (C) => C === h
        );
        if (!d)
          throw new Error(
            `Result ${String(h)} not defined for measure action: ${o}`
          );
        return a.endSpan(s, d, m);
      }
    };
  }
  function g(o, s, i) {
    const c = `with${S(o)}`, h = (m, d) => a.withSpan(m, {
      name: s,
      action: o,
      ...d
    });
    return {
      [c]: h
    };
  }
  function M(o, s, i) {
    const c = `run${S(o)}`, h = (m, d) => a.withSpan(m, {
      name: s,
      action: o,
      ...d
    })();
    return {
      [c]: h
    };
  }
  function E(o, s) {
    return `${o}-${s}`;
  }
}
function R(r) {
  return r.charAt(0).toUpperCase() + r.slice(1);
}
function S(r) {
  return r.includes("-") ? r.split("-").map((t) => R(t)).join("") : R(r);
}
class U {
  constructor(t) {
    this.logTransport = t;
  }
  info(t, e) {
    this.callTransport("INFO", t, e);
  }
  warn(t, e) {
    this.callTransport("WARN", t, e);
  }
  error(t, e) {
    this.callTransport("ERROR", t, e);
  }
  callTransport(t, e, n) {
    if (e instanceof Error || typeof e == "string") {
      this.logTransport[t](e, n);
      return;
    }
    try {
      this.logTransport[t](JSON.stringify(e), n);
    } catch (a) {
      console.error("Could not stringify message", a);
    }
  }
}
function L(r) {
  return r == null ? !0 : r instanceof Error ? !1 : typeof r == "string" ? r.trim().length === 0 : Array.isArray(r) ? r.length === 0 : typeof r == "object" ? Object.keys(r).length === 0 : !1;
}
class P {
  constructor(t, e, n) {
    this.team = t, this.service = e, this.logMeasure = n;
  }
  ERROR(t, e) {
    if (L(t))
      return;
    const n = t instanceof Error ? t : new Error(t), a = {
      ...e,
      logLevel: "ERROR",
      logMessage: n.message,
      team: this.team,
      service: this.service,
      ...this.prepareErrorCauseFromError(n)
    };
    j(n, a);
  }
  WARN(t, e) {
    this.logWithLabels("WARN", t, e);
  }
  INFO(t, e) {
    this.logWithLabels("INFO", t, e);
  }
  prepareMessageAsStringOrError(t) {
    return typeof t == "string" ? { logMessage: t } : t instanceof Error ? {
      logMessage: t.toString(),
      ...this.prepareErrorCauseFromError(t)
    } : { logMessage: JSON.stringify(t) };
  }
  prepareErrorCauseFromError(t) {
    return L(t.cause) ? {} : t.cause instanceof Error ? { errorCause: t.cause.toString() } : { errorCause: JSON.stringify(t.cause) };
  }
  logWithLabels(t, e, n) {
    if (L(e))
      return;
    const a = this.prepareMessageAsStringOrError(e);
    this.logWithSpan(t, {
      ...a,
      ...n ?? {},
      logLevel: t,
      team: this.team,
      service: this.service
    });
  }
  logWithSpan(t, e) {
    const n = () => {
    };
    switch (t) {
      case "WARN":
        this.logMeasure.runLogWarn(n, {
          successResult: w.LogWarn,
          extraLabels: e
        });
        break;
      case "INFO":
        this.logMeasure.runLogInfo(n, {
          successResult: w.LogInfo,
          extraLabels: e
        });
        break;
    }
  }
}
function J(r, t) {
  const e = x(
    N.Custom,
    r,
    t
  );
  return new U(new P(r, t, e));
}
function z(r, t, e) {
  const n = new Error(
    `Deprecated method called: '${t}'. ${e ?? ""}`.trim()
  );
  r.error(n);
}
export {
  $ as ALL_MEASUREMENTS_DATA,
  A as Action,
  k as ApmAdapter,
  v as CUSTOM_MODEL,
  I as INIT_MODEL,
  P as LogTransportApm,
  U as LoggingService,
  N as MeasureType,
  W as PROCESSING_MODEL,
  w as Result,
  J as createLoggingService,
  x as createMeasureServiceFor,
  z as logDeprecatedUsage
};
